// extracted by mini-css-extract-plugin
export var content = "_r9-1";
export var noScroll = "_r9-3";
export var paper = "_r9-0";
export var scrollable = "_r9-2";